import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

/**
 * Shared chrome for Admin → Labs. Every lab answers one question and
 * tells you how to start — keep copy short.
 */
export default function LabHeader({ icon, iconColor = '#A78BFA', title, question, how, children }) {
  return (
    <View style={styles.wrap}>
      <View style={styles.top}>
        <View style={styles.titleRow}>
          {icon ? <Ionicons name={icon} size={20} color={iconColor} /> : null}
          <Text style={styles.title}>{title}</Text>
        </View>
        {children ? <View style={styles.actions}>{children}</View> : null}
      </View>
      {question ? <Text style={styles.question}>{question}</Text> : null}
      {how ? <Text style={styles.how}>{how}</Text> : null}
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: { marginBottom: 14, gap: 4 },
  top: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 12,
    flexWrap: 'wrap',
  },
  titleRow: { flexDirection: 'row', alignItems: 'center', gap: 8, flexShrink: 1 },
  title: { color: '#fff', fontSize: 20, fontWeight: '700', letterSpacing: -0.3 },
  actions: { flexDirection: 'row', alignItems: 'center', gap: 8, flexWrap: 'wrap' },
  question: { color: 'rgba(255,255,255,0.72)', fontSize: 13.5, lineHeight: 20, maxWidth: 720 },
  how: { color: 'rgba(255,255,255,0.42)', fontSize: 12, lineHeight: 18, maxWidth: 720 },
});
